import { render } from "./aio-login-woocommerce-card.vue?vue&type=template&id=f5d5fc78&scoped=true"
import script from "./aio-login-woocommerce-card.vue?vue&type=script&lang=js"
export * from "./aio-login-woocommerce-card.vue?vue&type=script&lang=js"

import "./aio-login-woocommerce-card.vue?vue&type=style&index=0&id=f5d5fc78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d5fc78"]])

export default __exports__